import React, { Component } from 'react';
import { AlertMsg } from './AlertMsg';
import { AlertMsgDtl } from './AlertMsgDtl';
import { ClodMsg } from './ClodMsg';
import { ClodMsgDtl } from './ClodMsgDtl';
import { HeaderSub } from '../../Common/HeaderSub'

import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능: 알림 및 공지사항 메인
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.AlertMsg,  //기본 컴포넌트 할당
            IConClassName: "delete",
            ContentState: null
        };
        this.Trash = React.createRef();
        this.handleTrash_Click = this.handleTrash_Click.bind(this);
    }
    //호출할 컴포넌트 이름
    CompName = {
        "AlertMsg": "AlertMsg",
        "AlertMsgDtl":"AlertMsgDtl",
        "ClodMsg": "ClodMsg",
        "ClodMsgDtl": "ClodMsgDtl"
    }
    //초기화
    componentDidMount() {

        //메인 알림에서 공지 상세로 직접 이동할 때
        if (Big3Common.Util.GetParams("Notino") !== null) {
            const Notino = Big3Common.Util.GetParams("Notino");
            const Noti_Idx = Big3Common.Util.GetParams("Noti_Idx");
            const WUid = Big3Common.Util.GetParams("WUid");
            this.setState({
                RenderName: this.CompName.ClodMsgDtl,
                ContentState: {
                    Notino: Notino,
                    Noti_Idx: Noti_Idx,
                    WUid: WUid
                }
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    handleTrash_Click() {
        if (this.state.IConClassName === "delete") {
            this.setState({ IConClassName: "alert_check" })
            this.Trash.current.handleTrash_Click(true);
        }
        else {
            this.setState({ IConClassName: "delete" });
            this.Trash.current.handleTrash_Click(false);
        }
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.AlertMsg) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="알림"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                        IConClassName={this.state.IConClassName}
                        IConClick={this.handleTrash_Click}
                    />
                    <AlertMsg
                        ref={this.Trash}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.AlertMsgDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="알림"
                        ComponentUrl="AlertMsg"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}

                    />
                    <AlertMsgDtl
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.ClodMsg) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="알림"
                        ComponentUrl="AlertMsg"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ClodMsg
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.ClodMsgDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="Clo:D 공지"
                        ComponentUrl="ClodMsg"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ClodMsgDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }

    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
